module.exports = __webpack_public_path__ + "images/luxe-3-95d8a2823bddff096b855b1fbc93f038.jpg";